import React, { useEffect, useRef, useState } from "react";
import { SketchPicker } from "react-color";
import { SilentErrorBoundary } from './SilentErrorBoundary';

const DEFAULT_PICKER_COLOR = "#000000";

const normalizePickerColor = (color) => {
  if (typeof color === "string" && color.trim()) {
    return color;
  }

  if (color?.hex) {
    return color.hex;
  }

  return DEFAULT_PICKER_COLOR;
};

function useClickOutside(
  ref,
  onClickOutside
) {
  useEffect(() => {
    function handleClickOutside(event) {
      if (
        ref && ref.current && !ref.current.contains(event.target)
      ) {
        onClickOutside();
      }
    }

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [ref, onClickOutside]);
}


const ColorPicker = ({ color, onColorSelect, onColorHover, onClose }) => {
  const ref = useRef(null)
  const safeColor = normalizePickerColor(color);
  const [initialColor] = useState(safeColor);

  useClickOutside(ref, onClose)

  return (
    <SilentErrorBoundary>
      <div className="color-picker" ref={ref}>
        <SketchPicker
          color={safeColor}
          onChange={(color) => onColorHover(normalizePickerColor(color))}
          onChangeComplete={(color) => onColorHover(normalizePickerColor(color))}
        />
        <div className="color-picker-buttons">
          <button
            className="add-field-button"
            onClick={() => onColorSelect(initialColor)}
          >
            Cancel
          </button>
          <button
            className="add-field-button"
            onClick={() => onColorSelect(safeColor)}
          >
            Apply
          </button>
        </div>
      </div>
    </SilentErrorBoundary>
  );
};

export default ColorPicker;
